var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{attrs:{"id":"search-form"}},[_c('input',{staticClass:"form-control-6 input is-success",attrs:{"placeholder":"Voice Search","focus":"","outlined":""}})]),_c('p',{staticClass:"info"})])
}]

export { render, staticRenderFns }